export default __webpack_public_path__ + "assets/check-icon-component.ed4a5ee3.svg";